import { PageHero } from "@/components/PageHero";
import { PrimaryCTA, OutlineCTA } from "@/components/CTA";
import { Reveal } from "@/components/Reveal";
import { StickyNote } from "@/components/Notebook";
import { PageMeta } from "@/components/PageMeta";
import { ROUTES } from "@/config/links";

/**
 * Placeholder page for routes that exist in the sitemap but are being
 * finalised in a later phase. Keeps site chrome (Nav/Footer/StickyCTA)
 * visible so no click lands on a blank document.
 *
 * `noindex` is set — these are thin, near-duplicate placeholder pages and
 * should not compete with real content in search results while in this
 * state. Not added to sitemap.xml either (see PRD).
 */
export default function ComingSoon({ title = "Coming soon", note, path = "/insights", titleKey, descriptionKey }) {
  return (
    <>
      <PageMeta
        titleKey={titleKey}
        descriptionKey={descriptionKey}
        path={path}
        noindex
      />
      <PageHero
        testId="coming-soon-hero"
        eyebrow="In rehearsal"
        headline={[title]}
        emphasis="This page is being prepared."
        emphasisAccent="none"
        intro={
          note ||
          "We're finalising this page in the coming days. In the meantime, book a consultation or send us a message — we'd love to hear about your moment."
        }
      >
        <PrimaryCTA href={ROUTES.booking} testId="coming-book-cta" location="hero" targetService="general_booking">
          Book a Free Consultation
        </PrimaryCTA>
        <OutlineCTA href={ROUTES.contact} testId="coming-contact-cta" location="hero" targetAssetId="contact_request">
          Send a message
        </OutlineCTA>
      </PageHero>

      <section className="relative z-10 pb-32 md:pb-40">
        <div className="max-w-[900px] mx-auto px-5 md:px-10 text-center">
          <Reveal>
            <StickyNote rotate={-2} color="#E7DDC8" className="inline-block">
              come back soon — the page is in the rehearsal room
            </StickyNote>
          </Reveal>
        </div>
      </section>
    </>
  );
}
